import { ButtonAction } from 'pages/NotifyEvent/styles';


export interface INextTreatment {
  forwardToFinish({ type }: {
    type: 'forward' | 'finish';
  }): void
  actionsBack: string
  rendered: boolean
}

export default function NextTreatment({ forwardToFinish, actionsBack, rendered }: INextTreatment) {
  if (!rendered) return null
  return (
    <ButtonAction
      data-testid="test-next-button"
      type="button"
      onClick={() => forwardToFinish({ type: 'forward' })}
      onKeyUp={(e) => e.key === 'ArrowRight' && forwardToFinish({ type: 'forward' })}
      className={actionsBack}
    >
      Próxima etapa
    </ButtonAction>
  )
}
